import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FamilyLeadsWidget from "./FamilyLeadsWidget";
import MetaSetupWidget from "./MetaSetupWidget";
import SiteSettingsWidget from "./SiteSettingsWidget";
import TrafficInsightsWidget from "./TrafficInsightsWidget";

const tabs = {
  leads: { label: "Leads & attribution", title: "Incoming lead intelligence" },
  traffic: { label: "Traffic & journeys", title: "Website traffic & journeys" },
  meta: { label: "Meta setup", title: "Meta connection & instructions" },
  media: { label: "Brand & media", title: "Landing page media" },
};

export default function AdminDashboard() {
  const [ready, setReady] = useState(false);
  const [tab, setTab] = useState("leads");
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/api/session.php", { credentials: "same-origin" })
      .then((response) => response.json())
      .then((data) => data.authenticated ? setReady(true) : navigate("/login?next=/admin", { replace: true }))
      .catch(() => navigate("/login?next=/admin", { replace: true }));
  }, [navigate]);

  async function logout() {
    await fetch("/api/logout.php", { method: "POST", credentials: "same-origin" }).catch(() => {});
    navigate("/login", { replace: true });
  }

  if (!ready) return <div className="admin-loading">Checking admin session…</div>;

  return (
    <div className="admin-shell">
      <aside>
        <a className="admin-logo" href="/"><span className="brand-mark">FIG</span><b>Family Income Guard</b></a>
        <nav>
          {Object.entries(tabs).map(([key, item]) => (
            <button key={key} className={tab === key ? "active" : ""} onClick={() => setTab(key)}>{item.label}</button>
          ))}
        </nav>
        <button className="logout" onClick={logout}>Sign out</button>
      </aside>
      <main>
        <header>
          <div><span>Family Income Guard control room</span><h1>{tabs[tab].title}</h1></div>
          <div className="admin-header-actions"><a href="/client-portal?preview=1" target="_blank" rel="noreferrer">Preview Lead Path ↗</a><a href="/" target="_blank" rel="noreferrer">View website ↗</a></div>
        </header>
        {tab === "leads" && <FamilyLeadsWidget />}
        {tab === "traffic" && <TrafficInsightsWidget />}
        {tab === "meta" && <MetaSetupWidget />}
        {tab === "media" && <SiteSettingsWidget />}
      </main>
    </div>
  );
}
